import { capFloat } from "./cap-float";

/**
 * This function calculates the average of an array of numbers.
 * @param arr
 * @returns
 */
export function average(arr: number[]): number {
	if (arr.length === 0) return 0;
	const curr = arr.reduce((a, b) => a + b, 0) / arr.length;
	return capFloat(curr);
}

/**
 * This function calculates the average of a number by the total.
 * @param count
 * @param total
 * @returns
 */
export function averageByTotal(count: number, total: number): number {
	if (count === 0) return 0;
	return total / count;
}
